/**
 * Definition ids the UI is hard-coupled to by behaviour, not by display.
 *
 * These are the only two integrations the frontend treats specially — Graylog
 * gates a whole Platform's routes and owns a setup wizard, Microsoft owns its
 * own onboarding flow. Everything else about an integration (its name, its
 * category, whether we support it) comes from the available-integrations
 * catalog, never from a hand-maintained list (ADR 0019).
 *
 * Do NOT grow this into an id→name map again. If you need a friendly name,
 * use `useAvailableIntegrationsMap` / `useGetLogSourceName`.
 */
export const GRAYLOG_DEFINITION_ID = '51d5d953-c8d5-5f56-8105-71efdcf856b2'

/** "Microsoft All in One" — the definition the Microsoft onboarding flow targets. */
export const MICROSOFT_DEFINITION_ID = '0971a0bf-61a2-5b3a-9cf4-dc7c455ec62f'

/** Definition ids that carry a guided setup wizard instead of the plain form. */
export const ONBOARDING_IDS: Array<string> = [GRAYLOG_DEFINITION_ID]

/**
 * Check if an integration has an onboarding process
 * @param integration_id - The id of the integration
 * @returns Whether the integration has an onboarding process
 */
export function integrationHasOnboarding(integration_id: string) {
	return ONBOARDING_IDS.includes(integration_id)
}
